<template>
  <div>
    <b-card id="container-request">
      <div class="row col-12"
           slot="header"
      >
        <h3>Solicitud de Materiales</h3>
      </div>
      <div style="text-align: right;margin-bottom: 5px;">
        <span>
          Viendo documentos que ingresaron
        </span>
        <span v-if="rangeSelected.valor !== 'personalizado'">
          {{ rangeSelected.nombre }}
        </span>
        <span v-if="rangeSelected.valor === 'personalizado'">
          entre el
          <datetime
            v-model="rangeFrom"
            input-class="input-date"
            :phrases="{ok: 'Seleccionar',
             cancel: 'Cancelar'}"
            value-zone="local"
            format="yyyy-MM-dd"
          />
          y el
          <datetime
            v-model="rangeUntil"
            input-class="input-date"
            :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
            value-zone="local"
            format="yyyy-MM-dd"
          />
          <span>
            <vs-button
              radius
              class="ml-3 d-inline"
              color="primary"
              type="border"
              icon="search"
              size="small"
              @click="materialRequest()"
            />
          </span>
        </span>
        <vs-dropdown vs-trigger-click style="margin-left: 15px">
          <a class="a-icon" href="#">
            Cambiar
            <vs-icon class="" icon="expand_more"></vs-icon>
          </a>
          <vs-dropdown-menu>
            <vs-dropdown-item
              style="width:200px"
              v-for="range in ranges"
              :key="range.valor"
              v-on:click.native="selectRange(range)"
            >
              {{ range.nombre }}
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <div class="row my-3">
      </div>
      <form
        autocomplete="off"
        data-vv-scope="search-material"
        @submit.prevent
      >
        <div class="row mb-5">
          <div class="col-md-4">
            <label>Solicitante</label>
            <ListUser
              label=""
              name="targetUserId"
              placeholder="Usuario"
              v-model="searchRequestName"
            />
          </div>
          <div class="col-md-3">
            <label>Estado</label>
            <select
              type="select"
              class="form-control"
              v-model="searchStatus"
            >
              <option
                selected
                v-bind:value="{value: 0, text: ''}"
              ></option>
              <option
                v-for="option in listStatus"
                v-bind:value="{ value: option.key, text: option.name}"
                v-bind:key="option.key"
              >
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="col-md-3"></div>
          <div class="col-md-2 align-self-end">
            <vs-chip
              style="cursor:pointer;"
              @click.native="materialRequest"
            >
              <vs-avatar icon="search" color="primary" />
              <strong>Buscar</strong>
            </vs-chip>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-12">
          <b-table
            hover
            :fields="fieldMaterialsRequest"
            :items="listMaterialsRequest"
          >
            <template #cell(monto)="row">
              {{ row.item.precioSolicitudTotal | toCurrency }}
            </template>
            <template #cell(statusCode)="row">
              <vs-chip
                v-if="row.item.statusCode === materialState.CREATED"
                :title="row.item.statusDescription"
              >
                <vs-avatar icon="schedule" color="#43C3B9" />
                {{ row.item.statusDescription }}
              </vs-chip>
              <vs-chip
                v-if="row.item.statusCode === materialState.APPROVED"
                :title="row.item.statusDescription"
              >
                <vs-avatar icon="schedule" color="#26bd6a" />
                {{ row.item.statusDescription }}
              </vs-chip>
            </template>
            <template #cell(action)="row">
              <b-button
                size="sm"
                v-on:click="getRequestDetail(row.item.id)"
              >
                <feather-icon icon="SearchIcon" />
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </b-card>
    <div class="row col-12">
      <div class="col-lg-4">
        <div class="mt-5">
          Mostrando
          <select
            v-model="rowspp"
            @change="materialRequest"
          >
            <option value="10" selected="selected">10</option>
            <option value="15">15</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select> registros por página.
        </div>
      </div>
      <div class="col-lg-8">
        <vs-row>
          <vs-col
            vs-w="12"
            class="mt-4"
          >
            <fb-paginacion
              :total="pagination.pages"
              v-model="actualPage"
              v-on:change="onPageChange"
            />
          </vs-col>
        </vs-row>
      </div>
    </div>
    <PopUpRequestDetail
      ref="fromRequestDetailModal"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import MaterialRequestState from '@/febos/global/materialsRequests/mixins/MaterialRequestState';
import FbPaginacion from '@/febos/chile/_vue/componentes/FbPaginacion';
import { DATE_RANGE_LAST_6_MONTH, DATE_RANGES } from '@/febos/chile/commons/dateCommons';
import PopUpRequestDetail from '@/febos/global/materialsRequests/vistas/modals/PopUpRequestDetail';
import ListUser from '@/febos/chile/lists/components/ListUser';

export default {
  name: 'MaterialsRequest',
  components: {
    FbPaginacion,
    PopUpRequestDetail,
    ListUser
  },
  data() {
    return {
      materialState: MaterialRequestState,
      queryFilters: this.$route.query.filters,
      listMaterialsRequest: [],
      listStatus: [
        { key: '1', name: 'Creada' },
        { key: '2', name: 'Aprobada' },
      ],
      stateMaterial: '',
      searchRequestName: '',
      searchStatus: null,
      rowspp: Number.parseInt(this.$route.query.paginate || 10, 10),
      actualPage: 1,
      ranges: DATE_RANGES,
      rangeSelected: this.defaultDate ? this.defaultDate : DATE_RANGE_LAST_6_MONTH,
      rangeFrom: '',
      rangeUntil: '',
      currentFilters: '',
      arrayFilter: [],
    };
  },
  watch: {
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#container-request > .con-vs-loading');
        return;
      }
      this.$vs.loading({
        container: '#container-request',
        scale: 0.6
      });
    },
    listMaterialsRequests(value) {
      this.listMaterialsRequest = value;
    },
  },
  mounted() {
    this.materialRequest();
  },
  created() {
    this.rangeFrom = this.$moment().subtract(6, 'month').format('YYYY-MM-DD');
    this.rangeUntil = this.$moment().format('YYYY-MM-DD');
  },
  computed: {
    ...mapGetters('Materials', [
      'loading',
      'listMaterialsRequests',
      'pagination',
      'fieldMaterialsRequest',
      'materialRequestsDetail'
    ]),
    page: {
      get() {
        return this.value;
      },
      set(modifiedValue) {
        this.$emit('input', modifiedValue);
      }
    },
  },
  methods: {
    ...mapActions('Materials', [
      'loadListMaterialsRequests',
      'loadListMaterialRequest',
      'loadMaterialRequestDetail'
    ]),
    ...mapActions('Modals', [
      'showModals',
      'closeModal'
    ]),
    openModalRequestDetail() {
      this.showModals('PopUpRequestDetail');
    },
    async getRequestDetail(idRequest) {
      const query = {
        params: {
          tipo: 'solicitud_material',
          id: idRequest
        }
      };
      await this.loadMaterialRequestDetail(query);
      this.openModalRequestDetail();
    },
    async materialRequest() {
      const filterContent = this.setArrayFilter();
      await this.loadListMaterialRequest({
        orden: '-createdAt',
        pagina: this.actualPage,
        filtros: filterContent !== '' ? filterContent : 'statusCode:1',
        itemsPorPagina: this.rowspp
      });
    },
    onPageChange() {
      this.materialRequest();
    },
    setArrayFilter() {
      this.arrayFilter = [];
      if (this.searchRequestName) {
        this.arrayFilter.push({
          campo: 'createdBy',
          valor: this.searchRequestName
        });
      }
      if (this.searchStatus !== null && this.searchStatus.value !== 0) {
        this.arrayFilter.push({
          campo: 'statusCode',
          valor: this.searchStatus.value
        });
      }
      const rangeFrom = this.$moment(this.rangeFrom).format('YYYY-MM-DD');
      const rangeUntil = this.$moment(this.rangeUntil).format('YYYY-MM-DD');
      this.arrayFilter.push({
        campo: 'dateRequest',
        // valor: `${rangeFrom}--${rangeUntil}`
        valor: rangeFrom.concat('--').concat(rangeUntil)
      });
      const filter = [];
      this.arrayFilter.forEach((item) => {
        if (item.campo === 'createdBy') filter.push(`${ item.campo }$${ item.valor }`);
        else filter.push(`${ item.campo }:${ item.valor }`);
      });
      return filter.join('|');
    },
    selectRange(range) {
      switch (range.valor) {
        case 'ultimas4semanas':
          this.rangeFrom = this.$moment().subtract(28, 'days')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
        case 'esteMes':
          this.rangeFrom = this.$moment().startOf('month')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
        case 'esteMesConAnterior':
          this.rangeFrom = this.$moment().subtract(2, 'month').startOf('month')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
        case 'ultimos3meses':
          this.rangeFrom = this.$moment().subtract(3, 'month').startOf('month')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
        case 'ultimos6meses':
          this.rangeFrom = this.$moment().subtract(6, 'month').startOf('month')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
        default:
          this.rangeFrom = this.$moment().subtract(6, 'month').startOf('month')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
      }
      this.rangeSelected = range;
      this.materialRequest();
    },
  },

};
</script>
<style scoped>
</style>
